import { DeleteRequest, GetRequest, PostRequest } from "../../plugins/https";
import { deleteCarousel, getCarousel, setCarousel } from "./action";
import { DELETE_CAROUSEL, GET_CAROUSEL, SET_CAROUSEL } from "./actionType";

export const addCarousel = (Carousel) => async (dispatch) => {
  try {
    const response = await PostRequest(`/carousel`, Carousel);
    dispatch(setCarousel(response.data));
  } catch (error) {
    console.error(error);
  }
};

export const getCarouselData = () => async (dispatch) => {
  try {
    const res = await GetRequest(`/carousel`);
    dispatch(getCarousel(res.data));
  } catch (error) {
    console.error("Error getting Carousel: ", error);
  }
};

export const deleteCarouselData = (id, photo) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/carousel/${id}/${photo}`);
    dispatch(deleteCarousel(id, photo));
  } catch (error) {
    console.error("Error in deleting carousel: ", error);
  }
};

const initialState = {
  carousel: "",
  carouselData: [],
};

export const carouselReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAROUSEL:
      return {
        ...state,
        carousel: action.payload,
      };
    case GET_CAROUSEL:
      return {
        ...state,
        carouselData: action.payload,
      };
    case DELETE_CAROUSEL:
      return {
        ...state,
        carouselData: state.carouselData.filter(
          (item) => item.id !== action.payload
        ),
      };
    default:
      return state;
  }
};
